import { OutlineButton } from 'components/UI/Buttons';
import Colors from 'enums/Colors';
import ComponentArrasteSolte from 'models/componentInteraction/ComponentArrasteSolte';
import ComponentArrasteSolteQuestion from 'models/componentInteraction/ComponentArrasteSolteQuestion';
import ComponentArrasteSolteQuestionAlternativa from 'models/componentInteraction/ComponentArrasteSolteQuestionAlternativa';
import { ButtonHomeSolftBlueV2, ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import React, { useEffect, useState } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { BsEmojiNeutralFill } from 'react-icons/bs';
import { FaCheck, FaCheckCircle, FaSadTear } from 'react-icons/fa';
import { ImHappy2 } from 'react-icons/im';
import { IoIosCloseCircle, IoMdHappy } from 'react-icons/io';
import { IoReloadCircleSharp } from 'react-icons/io5';
import { RxDragHandleHorizontal } from 'react-icons/rx';
import styled from 'styled-components';

const Styled = {
    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 600;
        font-size: 22px;
        line-height: 25.2px;
        letter-spacing: 0%;
        text-align: center;
        vertical-align: middle;
        color: ${Colors.Blue};
    `,

    Content: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
    `,

    Feedback: styled.div`
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 1rem;
        padding: 22px;
    `,

    TitleFeed: styled.h1`
        color: ${Colors.Blue};
        font-size: 28px;
        font-weight: 700;
    `,

    ContentFeed: styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        background-color: #fafafa;
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 18px;
        line-height: 25.2px;
        letter-spacing: 0%;
        text-align: center;
        vertical-align: middle;
        padding: 32px;
        gap: 1rem;
    `,
};

interface IComponentArrasteSoltePublic {
    dados: ComponentArrasteSolte;
}

type DropZoneType = 'Verdadeiro' | 'Falso';
type CardData = {
    id: string;
    text: string;
    correct: DropZoneType;
};

const DraggableCard: React.FC<{ onDrop: () => void; isDropped: boolean; card: ComponentArrasteSolteQuestion }> = ({
    onDrop,
    isDropped,
    card,
}) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'CARD',
        item: { id: card.codigo },
        end: (item, monitor) => {
            if (monitor.didDrop()) onDrop();
        },
        collect: monitor => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));

    return (
        <div
            ref={drag}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                position: 'relative',
                opacity: isDragging || isDropped ? 0.3 : 1,
                border: '1px solid #ccc',
                height: 160,
                width: 240,
                margin: 16,
                padding: 16,
                backgroundColor: '#fafafa',
                textAlign: 'center',
                cursor: 'grab',
                color: Colors.Blue,
                fontWeight: 500,
            }}
        >
            {card.text}
            <div
                style={{
                    position: 'absolute',
                    bottom: 8,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    fontWeight: 'bold',
                }}
            >
                <RxDragHandleHorizontal size={22} />
            </div>
        </div>
    );
};

const DropZone: React.FC<{
    label: string;
    onDropCard: (dropTarget: string, isIncorret: boolean) => void;
    droppedCard?: string;
    card: ComponentArrasteSolteQuestionAlternativa;
    question: ComponentArrasteSolteQuestion;
    handleReset: (nextQuest: boolean) => void;
}> = ({ label, onDropCard, droppedCard, card, handleReset, question }) => {
    const isCorrect = true === card.correct;

    const [isThisZone, setThisZone] = useState<boolean>(false);

    const [{ isOver }, drop] = useDrop(() => ({
        accept: 'CARD',
        drop: () => {
            onDropCard(label, isCorrect === false);
        },
        collect: monitor => ({
            isOver: !!monitor.isOver(),
        }),
    }));

    useEffect(() => {
        setThisZone(droppedCard === label);
    }, [droppedCard, label]);

    return (
        <>
            <div
                ref={drop}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 160,
                    width: 240,
                    margin: 16,
                    padding: 16,
                    backgroundColor: isOver ? '#f0f0f0' : '#fafafa',
                    border: `4px solid ${isThisZone ? (isCorrect ? 'green' : 'red') : '#ccc'}`,
                    position: 'relative',
                    textAlign: 'center',
                    color: Colors.Blue,
                    fontWeight: 500,
                }}
            >
                {isThisZone ? <>{question.text}</> : <>{label}</>}

                {isThisZone && (
                    <>
                        <div
                            style={{
                                position: 'absolute',
                                top: '-16px',
                                left: '100%',
                                transform: 'translateX(-50%)',
                                color: isCorrect ? 'green' : 'red',
                                fontWeight: 'bold',
                                backgroundColor: '#fafafa',
                                borderRadius: '100%',
                            }}
                        >
                            {isCorrect ? <FaCheckCircle size={32} /> : <IoIosCloseCircle size={32} />}
                        </div>
                        {isCorrect ? (
                            <div
                                style={{
                                    position: 'absolute',
                                    bottom: '-54px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    color: isCorrect ? 'green' : 'red',
                                    fontWeight: 'bold',
                                }}
                            >
                                <ButtonHomeV2
                                    onClick={() => {
                                        setThisZone(false);
                                        handleReset(true);
                                    }}
                                >
                                    <FaCheck /> Avançar
                                </ButtonHomeV2>
                            </div>
                        ) : (
                            <div
                                style={{
                                    position: 'absolute',
                                    bottom: '-54px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    color: isCorrect ? 'green' : 'red',
                                    fontWeight: 'bold',
                                }}
                            >
                                <ButtonHomeV2
                                    style={{ width: '220px', backgroundColor: Colors.DeleteRed }}
                                    onClick={() => {
                                        setThisZone(false);
                                        handleReset(false);
                                    }}
                                >
                                    <IoReloadCircleSharp size={26} cursor={'pointer'} />
                                    Tentar novamente
                                </ButtonHomeV2>
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
};
const ComponentArrasteSoltePublic: React.FC<IComponentArrasteSoltePublic> = ({ dados }) => {
    const [indexQuestion, setIndexQuestion] = useState<number>(0);

    const [questions, setQuestions] = useState<ComponentArrasteSolteQuestion[]>(dados.questions);
    const [selectErros, setSelectErros] = useState<number>(0);

    const [droppedZone, setDroppedZone] = useState<string | undefined>();

    const handleDrop = (zone: string, isIncorret: boolean) => {
        setDroppedZone(zone);

        if (isIncorret) setSelectErros(selectErros + 1);
    };

    return (
        <DndProvider backend={HTML5Backend}>
            <div style={{ textAlign: 'center', paddingTop: 22 }}>
                <h1 style={{ fontSize: 22, color: Colors.Blue, fontWeight: 700, marginBottom: 22 }}>{dados.title}</h1>
                {questions &&
                    questions.length > 0 &&
                    questions.map((quest, index) => {
                        if (index === indexQuestion) {
                            return (
                                <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                    <h2 style={{ fontWeight: 600, color: Colors.Blue }}>
                                        Questão {index + 1}/{questions.length}
                                    </h2>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <DraggableCard isDropped={!!droppedZone} onDrop={() => {}} card={quest} />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 48 }}>
                                        {quest.alternativas &&
                                            quest.alternativas.length > 0 &&
                                            quest.alternativas.map((alt, index) => (
                                                <DropZone
                                                    key={index}
                                                    label={alt.text}
                                                    onDropCard={handleDrop}
                                                    droppedCard={droppedZone}
                                                    card={alt}
                                                    question={quest}
                                                    handleReset={next => {
                                                        setDroppedZone(undefined);
                                                        if (next) setIndexQuestion(indexQuestion + 1);
                                                    }}
                                                />
                                            ))}
                                    </div>
                                </div>
                            );
                        }
                    })}
                {indexQuestion + 1 > questions.length && (
                    <Styled.Feedback>
                        <Styled.ContentFeed>
                            {questions.length / 2 < selectErros && (
                                <>
                                    <ImHappy2 size={48} color={Colors.Yellow} />{' '}
                                    <Styled.TitleFeed>Vamos tentar de novo? Revisar o conteúdo pode te ajudar a avançar.</Styled.TitleFeed>
                                </>
                            )}
                            {questions.length / 2 >= selectErros && selectErros !== 0 && (
                                <>
                                    <ImHappy2 size={48} color={Colors.Blue} />{' '}
                                    <Styled.TitleFeed>Você está no caminho certo! Que tal revisar só alguns pontos?</Styled.TitleFeed>
                                </>
                            )}
                            {selectErros === 0 && (
                                <>
                                    <ImHappy2 size={48} color={Colors.BrightGreen} />{' '}
                                    <Styled.TitleFeed>Parabéns! Você mandou muito bem e acertou tudo!</Styled.TitleFeed>
                                </>
                            )}
                        </Styled.ContentFeed>
                        <OutlineButton
                            onClick={() => {
                                setIndexQuestion(0);
                                setSelectErros(0);
                            }}
                        >
                            Tentar novamente
                        </OutlineButton>
                    </Styled.Feedback>
                )}
            </div>
        </DndProvider>
    );
};

export default ComponentArrasteSoltePublic;
